import { Breakpoint, Breakpoints, breakpoints } from 'bold-ui'

/** Faixa com limite inferior inclusivo e superior exclusivo. */
export function betweenBreakpoints(breakpoints: Breakpoints, lower: Breakpoint, upper: Breakpoint): string {
  return `@media (min-width: ${breakpoints.size[lower]}px) and (max-width: ${breakpoints.size[upper] - 1}px)`
}

// O -1 alinha com o `useViewportType.isMobile` (`innerWidth < sm`); o `breakpoints.down('sm')` do bold inclui os 600px
export const mediaMobile = `@media (max-width: ${breakpoints.sm - 1}px)`

// O -1 deixa os 960px para a faixa seguinte
export const mediaDownMd = `@media (max-width: ${breakpoints.md - 1}px)`
